<div class="relative w-screen font-bold text-[50rem] leading-none text-center text-gray-300"> {{ code }}</div>
<div class="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 p-8 rounded-xl bg-gray-100 text-5xl">
  {{ message }}
</div>
